import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
type ProgramOverViewContentProps = {
    programDetailObject:any;
}

export const ProgramOverViewContent : React.FC<ProgramOverViewContentProps> = ({programDetailObject})=>{
  const { t } = useTranslation();
  const imageAccessToken = programDetailObject?.bannerImage?.split('cp_oauth_jwt=')[1];
  
  const getOverviewContent = (htmlString: string) => {
    return parse(htmlString, {
      replace: (domNode: any) => {
        if (domNode?.name === "img" && domNode?.attribs?.src && !domNode?.attribs?.src?.includes('cp_oauth_jwt')) {
          domNode.attribs.src = domNode?.attribs?.src?.concat(`?cp_oauth_jwt=${imageAccessToken}`);
        }
        return domNode;
      },
    });
  }

    return <div className="flow-root">
    <h4 className="text-xl lg:text-2xl xl:text-2xl font-barlowLight mb-2">
      {programDetailObject?.name}
    </h4>
    <p className="leading-7  text-base font-barlowLight text-editor-class">
      {programDetailObject?.richTextOverview && getOverviewContent(programDetailObject?.richTextOverview)}
    </p>
    {
      !programDetailObject?.overview && <div className=" flex justify-center w-full text-2xl">
      <span dangerouslySetInnerHTML={{ __html: t('Common.noOverviewContent') }} />
      </div> 
    }
  </div>

}